import React, { useState } from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import TextField from '@mui/material/TextField';
import ReactLoading from 'react-loading';
import mode from './Mode';
import { ResetEmailSchema } from '../schemas';
import { useNavigate } from 'react-router-dom';
import '../styles/resetPassword.css';

const GiveEmail = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formMessage, setFormMessage] = useState({ type: '', text: '' });
    const navigate = useNavigate();
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/general/' : 'http://127.0.0.1:8000/general/';

    const onSubmit = () => {
        setIsLoading(true);
        setFormMessage({ type: '', text: '' });
        const email = values.email;
        axios.post(baseurl + 'check-email/', {
            email: values.email
        }).then((resp) => {
            const { status_code, message, code } = resp.data;
            if (status_code === 200) {
                setFormMessage({ type: 'success', text: 'Success! Check your email for the OTP. If you do not see it, check your spam folder.' });
                setTimeout(() => {
                    setIsLoading(false);
                    navigate('/reset-give-code', { state: { code: code, email: email } });
                }, 3000);
            } else {
                setFormMessage({ type: 'error', text: message || 'An error occurred. Please try again.' });
                setIsLoading(false);
            }
        }).catch((err) => {
            if (err.response && err.response.data && err.response.data.Msg) {
                setFormMessage({ type: 'error', text: 'Email provided is not registered.' });
            } else {
                setFormMessage({ type: 'error', text: 'An error occurred. Please try again.' });
            }
            setIsLoading(false);
        });
    };

    const { values, errors, handleBlur, touched, handleChange, handleSubmit } = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: ResetEmailSchema,
        onSubmit
    });

    return (
        <div className='reset-password-container'>
            
            <div className="reset-password-wrapper">
                
                <div className="reset-password-header">
                    <h1>Reset Password</h1>
                    <p>Enter your registered email to receive a password reset code.</p>
                </div>

                <form method="POST" className='reset-password-form' onSubmit={handleSubmit}>
                    {formMessage.text && (
                        <div className={`form-message ${formMessage.type}`}>
                            {formMessage.text}
                        </div>
                    )}
                    <div className='form-group'>
                        <label htmlFor="email">Email Address</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.email && touched.email)}
                            id="email"
                            variant="outlined"
                            name='email'
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                        />
                        {errors.email && touched.email && <p className='error-text'>{errors.email}</p>}
                    </div>


                    <button className="reset-password-btn" type="submit" disabled={isLoading}>
                        {isLoading ? <ReactLoading type="spin" color="#fff" height={25} width={25} /> : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default GiveEmail;